import { Button } from '@audio-network/componentlibrary'
import { Container } from '@audio-network/componentlibrary'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { LoadMoreProps } from './LoadMore.types'

const LoadMore = ({
	loading,
	onLoadMore,
	...props
}: LoadMoreProps): JSX.Element => {
	const { t } = useTranslation(['albums'])

	return (
		<div {...props}>
			<Container maxWidth="large">
				<Button spinner={loading} onClick={onLoadMore}>
					{t('load-more')}
				</Button>
			</Container>
		</div>
	)
}

export default LoadMore
